import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import { Links } from 'components/Links';
import { GlobalStyle } from 'styles';

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <Router>
      <Switch>
        <Route exact path="/">
          <App />
        </Route>
        <Route path="/links">
          <Links />
        </Route>
        <Redirect from="*" to="/" />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
